module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-duotone-900.woff2?071dad85141e5ae94ee3fddb79a589ae";